import axios from "axios";

// In production the frontend is served from the same host as the backend
// (e.g. biohackersports.com), so we want relative /api calls to avoid
// cross-origin CORS churn from the Emergent ingress. In preview we still
// hit the explicit REACT_APP_BACKEND_URL. The switch is derived at runtime
// from window.location.hostname so a single build works in every env.
function resolveBackendUrl() {
  const envUrl = process.env.REACT_APP_BACKEND_URL;
  if (typeof window === "undefined") return envUrl || "";
  const host = window.location.hostname;
  // Any custom domain (biohackersports.com, www.biohackersports.com, or a
  // preview hostname that already serves the frontend) is same-origin.
  const isSameOriginHost =
    host.endsWith("biohackersports.com") ||
    host.endsWith("preview.emergentagent.com") ||
    host === "localhost" || host === "127.0.0.1";
  if (isSameOriginHost) return window.location.origin;
  return envUrl || window.location.origin;
}

const BACKEND_URL = resolveBackendUrl();
export { BACKEND_URL };
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export default api;

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => (e?.msg || JSON.stringify(e))).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
